import { callBackendApi } from "../service/axios";

export function getInfoTabUsersTableContents(usersList) {
  return callBackendApi("post", `/bff/users?ids=${usersList}`);
}

export function getInfoTabMembersTableContents(userGroupUniqueName) {
  return callBackendApi("get", `/bff/user-group-members/${userGroupUniqueName}`);
}
